import "./index.scss";
export const CompanyLogo = ({logo}) => {
  return (
    <div className="client-company-logo">
      <img src={logo} alt="" />
    </div>
  );
};
